import React from 'react';
import { rotuloStatusContrato } from './Visualizar/Types/contratoStatus';

const STATUS_CLS = {
    ativo: 'bg-green-100 text-green-800',
    implantacao: 'bg-sky-100 text-sky-800',
    suspenso: 'bg-yellow-100 text-yellow-800',
    encerrado: 'bg-red-100 text-red-800'
};

const StatusBadge = ({ status }) => (
    <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-semibold ${STATUS_CLS[status] || 'bg-gray-100 text-gray-700'}`}>
        {rotuloStatusContrato(status)}
    </span>
);

const SeletorContrato = ({ contratos = [], onSelecionar, titulo = 'Selecione o contrato' }) => (
    <div className="p-4">
        <h3 className="text-lg font-semibold mb-3">{titulo}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {contratos.map((ct) => (
                <button
                    key={ct.id}
                    type="button"
                    onClick={() => onSelecionar(ct)}
                    className="text-left border border-gray-300 dark:border-gray-600 rounded-lg p-3 hover:border-vox-blue-600 hover:bg-vox-blue-50 dark:hover:bg-gray-700 transition-colors bg-white dark:bg-gray-800"
                >
                    <div className="font-semibold text-gray-900 dark:text-gray-100">
                        {ct.nome}
                    </div>
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        {ct.numero ? `Nº ${ct.numero} · ` : ''}tipo: {ct.tipo} · {ct.qtd_itens} item(ns)
                    </div>
                    {ct.status && (
                        <div className="mt-2">
                            <StatusBadge status={ct.status} />
                        </div>
                    )}
                </button>
            ))}
        </div>
    </div>
);

export default SeletorContrato;
